<template>
  <div class="page-wrapper">
    <div class="page-header">
      <WidgetToolbar :back="true" title="Accounts" :icon="require('@/assets/icon/accounts-active.svg')"
        @onBack="$navigationGoBack('/accounts')" @onTitleClick="$router.push({ path: '/accounts' })">
        <template #left-options>
          <accountSidebar switch_tab="overview" :account="account"></accountSidebar>
        </template>


        <div class="options">
          <widgetProfile :title="account.name" subtitle="" file_name="" path="" @click="
            $router.push({ path: '/accounts' })
            " titleDirection="left"></widgetProfile>
        </div>
      </WidgetToolbar>
    </div>

    <div class="page-body" v-if="account">
      <!-- Company Profile Section -->
      <div class="company-profile-wrapper">
        <div class="company-profile">
          <div class="profile-header">
            <div class="logo-section">

              <widgetProfile :title="account.name" :enableRightMargin="false" :size="60" :text_size="23" :subtitle="''"
                :file_name="null" :showContent="false" :path="$fullUrl('images/profiles/')"></widgetProfile>

              <div class="company-info">
                <div class="company-name">
                  <h2>{{ account.name }}</h2>
                  <span class="status-badge">
                    {{ account_status }}
                  </span>

                </div>
                <div class="location" v-if="false">
                  <img class="location-icon" src="@/assets/icons/account_overview/map-pin.svg" alt="location" />
                  {{ account.location | validate }}
                </div>
              </div>


            </div>

            <div class="account-opttions">
              <button class="action-btn edit" @click="updateAccount(account)">
                <img src="@/assets/icons/notes/pencil.svg" alt="edit" />
              </button>
              <button class="action-btn share" v-if="false">
                <img src="@/assets/icons/share-forward.svg" alt="share" />
              </button>


              <widgetDropdown v-model="toggle_more_action" :right="true" :hover="false" :interactive="true">
                <button class="action-btn more">
                  <img src="@/assets/icons/more.svg" alt="more" />
                </button>
                <div slot="dropdown" class="dropdown-widget right">
                  <app-dialog title="Delete Account" ask="Are you sure you want to delete this account?"
                    yesText="Delete" noText="Cancel" @onComfirm="deleteAccount(account.id)">
                    <button class="dropdown-item">
                      Delete
                    </button>
                  </app-dialog>
                </div>
              </widgetDropdown>
            </div>

          </div>

          <div class="company-details">
            <div class="detail-item">
              <img src="@/assets/icons/account_overview/bookmark.svg" alt="bookmark" />
              {{ account_category }}
            </div>
            <div class="detail-item" v-if="false">
              <img src="@/assets/icons/account_overview/phone.svg" alt="phone" />
              {{ account.phone | validate }}
            </div>
            <div class="detail-item" v-if="false">
              <img src="@/assets/icons/account_overview/email.svg" alt="email" />
              {{ account.email | validate }}
            </div>
          </div>

          <div class="description-section">
            <h3> <img width="17" src="@/assets/icons/account_overview/description.svg" alt="description" />
              Description</h3>
            <p v-html="account.description || 'No description'">
            </p>
          </div>

        </div>


        <!-- Contacts Section -->
        <div class="widget-container">
          <div class="widget-header">
            <h3>Recent Contacts</h3>
            <a class="view-more" @click.prevent="selectTab('account-contact')">Go To <img
                src="@/assets/icons/account_overview/arrow_right.svg" alt=""></a>
          </div>
          <div class="contacts-list">
            <table class="table-data">
              <thead class="table-header">
                <tr>
                  <th>Full Name & Location</th>
                  <th>Email & Phone</th>
                  <th>Contact Type</th>
                </tr>
              </thead>
              <tbody class="table-body">
                <template v-for="(item, index) in account.contacts.slice(0, 3)">
                  <tr :key="index" class="table-row" @click="showContactDetails(item.id)">
                    <td>
                      <div class="row">
                        <widgetProfile :title="item.first_name + ' ' + item.last_name"
                          :subtitle="processLocation(item.location)" file_name="" path="">
                        </widgetProfile>
                      </div>
                    </td>


                    <td>
                      <div class="email">
                        {{ item.email | validate }}
                      </div>
                      <div class="phone">
                        {{ item.phone_alt | validate }}
                      </div>
                    </td>
                    <td>
                      {{ item.contact_type == 'account_contact' ? 'Account Contact' : 'LIA Contact' }}
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>


            <div class="contact-avatars" v-if="false">
              <div v-for="(contact, index) in account.contacts.slice(0, 7)" :key="index" class="contact-item">
                <widgetProfile :title="contact.first_name + ' ' + contact.last_name" :enableRightMargin="false"
                  :size="60" :text_size="23" :subtitle="''" :file_name="null" :showContent="false"
                  :path="$fullUrl('images/profiles/')"></widgetProfile>
                <span class="contact-name">{{ contact.first_name + ' ' + contact.last_name }}</span>
              </div>
              <a v-if="account.contacts.length > 7" class="view-more" @click.prevent="selectTab('account-contact')">Go
                To
                <img src="@/assets/icons/account_overview/arrow_right.svg" alt="">
              </a>
            </div>
          </div>
          <div class="stats-section">
            <div class="total-stats">
              <span class="stat-label">Total Contacts</span>
              <div class="stat-number">{{ account.contact_stats.total }}</div>
            </div>
            <div class="stat-bars" v-if="account.contact_stats.total > 0">
              <div class="stat-item">
                <div class="percentage">{{ Math.round(account.contact_stats.lia_contacts /
                  account.contact_stats.total
                  * 100) }}%</div>

                <div class="progress-bar">
                  <div class="progress"
                    :style="{ width: (account.contact_stats.lia_contacts / account.contact_stats.total * 100) + '%' }">
                    <span class="stat-label">LIA Contacts</span>
                  </div>
                </div>
              </div>
              <div class="stat-item">
                <div class="progress-bar">
                  <div class="progress p-secondary "
                    :style="{ width: (account.contact_stats.account_contacts / account.contact_stats.total * 100) + '%' }">
                    <span class="stat-label">Account Contacts</span>
                  </div>
                </div>
                <div class="percentage p-secondary">{{ Math.round(account.contact_stats.account_contacts /
                  account.contact_stats.total * 100) }}%</div>

              </div>
            </div>
          </div>
        </div>


        <!-- Contacts Section -->
        <div class="widget-container">
          <div class="widget-header">
            <h3>Contracts</h3>
            <a class="view-more" @click.prevent="selectTab('attachments')">Go To <img
                src="@/assets/icons/account_overview/arrow_right.svg" alt=""></a>
          </div>
          <div class="attachments-section" v-if="account.attachments.length > 0">
            <h3> <img width="17" src="@/assets/icons/account_overview/attachment.svg" alt="attachment" />
              Attachment ({{ account.attachments.length }})</h3>
            <div class="attachment-files">
              <div class="file-item" v-for="attachment in account.attachments" :key="attachment.id">
                <div class="file-icon">PDF</div>
                <div class="file-info">
                  <span class="file-name">{{ attachment.title }}</span>
                  <span class="file-details"> {{ moment(attachment.created_at).format('DD MMM, YYYY') }}</span>
                </div>
                <div class="file-actions">
                  <button class="action-btn download" @click.prevent="downloadAttachment(attachment)">
                    <img src="@/assets/icons/account_overview/download.svg" alt="download" />
                  </button>
                </div>
              </div>

            </div>
          </div>
          <div class="attachments-section" v-else>
            <h3> <img width="17" src="@/assets/icons/account_overview/attachment.svg" alt="attachment" />
              Attachment (0)</h3>
            <p>No attachments added</p>
          </div>


          <div class="contracts-section">
            <h3>Total contracts signed</h3>
            <div class="contracts-signed">
              <span>{{ contract_stats.total }}</span>
            </div>
          </div>
        </div>

      </div>

      <div class="overview-grid">



        <div class="row-widget">
          <!-- Task Planner Section -->
          <div class="widget-container">
            <div class="widget-header">
              <h3>Task Planner</h3>
              <a class="view-more" @click.prevent="selectTab('tasks')">Go To <img
                  src="@/assets/icons/account_overview/arrow_right.svg" alt=""></a>
            </div>
            <div class="task-stats">
              <div class="total-tasks">
                <span class="stat-label">Active tasks</span>
                <div class="stat-number">{{ account.task_stats.active }}</div>
              </div>
              <div class="task-bars" v-if="account.task_stats.active > 0">
                <div class="task-bar">
                  <div class="progress-wrapper">
                    <div class="progress"
                      :style="{ height: (account.task_stats.unscheduled / account.task_stats.active * 100) + '%' }">
                      <span class="percentage">{{ Math.round(account.task_stats.unscheduled / account.task_stats.active
                        *
                        100) }}%</span>
                    </div>
                  </div>
                  <label>Unscheduled</label>
                </div>
                <div class="task-bar">
                  <div class="progress-wrapper">
                    <div class="progress"
                      :style="{ height: (account.task_stats.overdue / account.task_stats.active * 100) + '%' }">
                      <span class="percentage">{{ Math.round(account.task_stats.overdue / account.task_stats.active *
                        100)
                      }}%</span>
                    </div>
                  </div>
                  <label>Overdue</label>
                </div>
                <div class="task-bar">
                  <div class="progress-wrapper">
                    <div class="progress"
                      :style="{ height: (account.task_stats.today / account.task_stats.active * 100) + '%' }">
                      <span class="percentage">{{ Math.round(account.task_stats.today / account.task_stats.active * 100)
                      }}%</span>
                    </div>
                  </div>
                  <label>Today</label>
                </div>
                <div class="task-bar">
                  <div class="progress-wrapper">
                    <div class="progress"
                      :style="{ height: (account.task_stats.future / account.task_stats.active * 100) + '%' }">
                      <span class="percentage">{{ Math.round(account.task_stats.future / account.task_stats.active *
                        100)
                      }}%</span>
                    </div>
                  </div>
                  <label>Future</label>
                </div>
              </div>
            </div>
          </div>

          <!-- Leads Section -->
          <div class="widget-container">
            <div class="widget-header">
              <h3>Leads</h3>
              <a class="view-more" @click.prevent="selectTab('leads')">Go To <img
                  src="@/assets/icons/account_overview/arrow_right.svg" alt=""></a>
            </div>
            <div class="leads-stats">
              <div class="total-leads">
                <span class="stat-label">Active leads</span>
                <div class="stat-number">{{ account.leads_stats.total || 0 }}</div>
              </div>
              <div class="lead-bars" v-if="account.leads_stats.total > 0">
                <div class="lead-bar">
                  <div class="progress-wrapper">
                    <div class="progress"
                      :style="{ height: (account.leads_stats.won / account.leads_stats.total * 100) + '%' }">
                      <span class="percentage">{{ Math.round(account.leads_stats.won / account.leads_stats.total * 100)
                      }}%</span>
                    </div>
                  </div>
                  <label>Won</label>
                </div>
                <div class="lead-bar">
                  <div class="progress-wrapper">
                    <div class="progress"
                      :style="{ height: (account.leads_stats.lost / account.leads_stats.total * 100) + '%' }">
                      <span class="percentage">{{ Math.round(account.leads_stats.lost / account.leads_stats.total * 100)
                      }}%</span>
                    </div>
                  </div>
                  <label>Lost</label>
                </div>
                <div class="lead-bar" v-if="false">
                  <div class="progress-wrapper">
                    <div class="progress"
                      :style="{ height: (account.leads_stats.deleted / account.leads_stats.total * 100) + '%' }">
                      <span class="percentage">{{ Math.round(account.leads_stats.deleted / account.leads_stats.total *
                        100)
                      }}%</span>
                    </div>
                  </div>
                  <label>Deleted</label>
                </div>
              </div>
            </div>
          </div>
        </div>


        <!-- Activity Section -->
        <div class="widget-container">
          <div class="widget-header">
            <h3>Recent Activity</h3>
            <a class="view-more" @click.prevent="selectTab('activities')">Go To <img
                src="@/assets/icons/account_overview/arrow_right.svg" alt=""></a>
          </div>
          <div class="activity-stats">
            <div class="activity-panels">
              <div class="recent-activity">
                <template v-for="(item, index) in account.recent_activities">
                  <div class="activity-item" v-if="item.title" :key="index" @click="selectNote(item)">
                    <span class="activity-text">{{ item.title }}</span>
                    <span class="activity-time">
                      <template v-if="moment(item.created_at).isSame(moment(), 'day')">
                        {{ moment(item.created_at).format('HH:mm') }}
                      </template>
                      <template v-else-if="moment(item.created_at).isSame(moment().subtract(1, 'day'), 'day')">
                        Yesterday
                      </template>
                      <template v-else>
                        {{ moment(item.created_at).fromNow() }}
                      </template>
                    </span>
                  </div>
                  <div class="activity-item"
                    v-else-if="item.type == 'notes' || item.type == 'tasks' || item.type == 'leads'"
                    @click="selectNote(item)">
                    <span class="activity-text">{{ item.created_by }} {{ item.action }}</span>
                    <span class="activity-time">
                      <template v-if="moment(item.created_at).isSame(moment(), 'day')">
                        {{ moment(item.created_at).format('HH:mm') }}
                      </template>
                      <template v-else-if="moment(item.created_at).isSame(moment().subtract(1, 'day'), 'day')">
                        Yesterday
                      </template>
                      <template v-else>
                        {{ moment(item.created_at).fromNow() }}
                      </template>
                    </span>
                  </div>
                </template>
              </div>
            </div>
          </div>

        </div>


        <!-- lia Section -->
        <div class="widget-container">
          <div class="widget-header">
            <h3>Recent LIA</h3>
            <a class="view-more" @click="$router.push({ name: 'assignment' })">Go To <img
                src="@/assets/icons/account_overview/arrow_right.svg" alt=""></a>
          </div>
          <div class="lia-stats" v-if="internships && internships.length > 0">
            <div class="lia-panels">
              <div class="recent-lia">
                <div class="lia-item" v-for="(item, index) in internships.slice(0, 3)" :key="index">
                  <span class="lia-profile">
                    <widgetProfile v-if="item.company_name" :title="item.company_name" :size="30" :text_size="12"
                      :subtitle="processLocation(item.location)" :file_name="null" :showContent="true"
                      :path="$fullUrl('images/profiles/')">
                    </widgetProfile>
                    <widgetProfile v-else-if="item.account.account" :title="item.account.account.name" :size="30"
                      :text_size="12" :subtitle="processLocation(item.account.location)" :file_name="null"
                      :showContent="true" :path="$fullUrl('images/profiles/')">
                    </widgetProfile>
                  </span>
                  <span class="lia-title">{{ item.name }}</span>
                  <span class="lia-time">{{ item.created_at | formatDate }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="lia-genelated-section">
            <h3>Total LIAs Generated</h3>
            <div class="lia-generated">
              <span>{{ lia_stats.total }}</span>
            </div>
          </div>
        </div>

        <div style="display: block; padding-bottom: 56px;"></div>

      </div>
    </div>

    <!-- Add - Update Account Modal -->
    <addUpdateAccountModal v-if="show_form_add_update" :content="selected_account" @success="submitAccountData()"
      @close="show_form_add_update = false"></addUpdateAccountModal>

    <!-- Contact Details -->
    <contactDetailsModal v-if="show_contact_details_modal" :contact_id="contact_id"
      @close="show_contact_details_modal = false" :showContactOptions="false"></contactDetailsModal>

  </div>
</template>

<script>
import accountSidebar from "@/views/Accounts/components/account_sidebar.vue";
import addUpdateAccountModal from "@/views/Accounts/components/add_update_account_modal.vue";
import contactDetailsModal from "@/views/Accounts/components/contact_details_modal.vue";

export default {
  name: "genelar-info-profile",
  components: {
    accountSidebar,
    addUpdateAccountModal,
    contactDetailsModal,
  },
  props: {},
  data: () => {
    return {
      show_form_add_update: false,
      selected_account: null,
      toggle_more_action: false,
      account: null,
      internships: [],
      contract_stats: {
        total: 0
      },
      lia_stats: {
        total: 0
      },
      show_contact_details_modal: false,
      contact_id: null,
    };
  },
  mounted() {
    let vm = this;
    Promise.all([
      vm.getStartData(),
    ]).catch(error => {
      console.error('Error loading account data:', error);
    });
  },
  computed: {
    account_status() {
      return this.account.status == "active"
        ? "Active"
        : this.account.status == "passive"
          ? "Passive"
          : this.account.status == "onhold"
            ? "On Hold"
            : "";
    },
    account_category() {
      return this.account.category == "gold" || this.account.category == "Gold"
        ? "Gold"
        : this.account.category == "silver" || this.account.category == "Silver"
          ? "Silver"
          : this.account.category == "bronze" || this.account.category == "Bronze"
            ? "Bronze"
            : "";
    }
  },
  methods: {
    showContactDetails(id) {
      let vm = this;
      vm.contact_id = id;
      vm.show_contact_details_modal = true;
    },
    getAccountInternship() {
      let vm = this;
      vm.$store
        .dispatch("ACCOUNT_SINGLE_GET_INTERNSHIP", {
          account_id: vm.$route.params.id,
          contact_ids: vm.account.contacts.filter((contact) => contact.contact_type == "company_contact").map((contact) => contact.id),
        })
        .then((responce) => {
          vm.internships = responce.data.map((item) => {
            item.expanded = false;
            return item;
          });
        })
        .catch((error) => { });
    },
    getContractStats() {
      let vm = this;
      vm.$store.dispatch("ACCOUNT_SINGLE_GET_CONTRACT_STATS", {
        contact_ids: vm.account.contacts.filter((contact) => contact.contact_type == "company_contact").map((contact) => contact.id),
      })
        .then((response) => {
          vm.contract_stats = response.data.contract_stats;
          vm.lia_stats = response.data.lia_stats;
        })
        .catch((error) => { });
    },
    processLocation(locations) {
      let vm = this;
      let full_location = "";
      if (locations && Array.isArray(locations)) {
        locations.forEach((location, index) => {
          full_location += index == 0 ? location : ", " + location;
        });
      }
      return full_location;
    },
    selectTab(type) {
      let vm = this;
      vm.$router
        .push({
          name: "account-view",
          params: { type: type, id: vm.$route.params.id },
        })
        .catch((error) => { });
    },
    submitAccountData() {
      let vm = this;
      vm.show_form_add_update = false;
      vm.getStartData();
    },
    updateAccount(item) {
      let vm = this;
      vm.selected_account = item;
      vm.show_form_add_update = true;
    },
    deleteAccount(id) {
      let vm = this;
      vm.$store
        .dispatch("ACCOUNT_DELETE", { account_id: id })
        .then((response) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Account is now deleted",
            type: "success",
            duration: 3000,
          });
          vm.$navigationGoBack('/accounts');
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
          console.error({ error });
        });
    },
    downloadAttachment(item) {
      let vm = this;
      vm.$store
        .dispatch("ACCOUNT_SINGLE_ATTACHMENT_DOWNLOAD_FILE", {
          id: item.id,
          name: item.document,
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", item.document); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => console.log(error));
    },
    getStartData() {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("ACCOUNT_SINGLE_GET_ALL_DATA", {
          account_id: vm.$route.params.id,
        })
        .then((responce) => {
          vm.account = responce.data;
          vm.accounts_for_internship = {
            type: "many",
            accounts: [vm.account],
          };
          vm.selected_accounts = vm.account;
          Promise.all([
            vm.getContractStats(),
            vm.getAccountInternship()
          ]);
          vm.$store.dispatch("LOADER_CLOSE");
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f8f9fa;
  padding: 5px;

  .page-header {
    height: 38px;
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 5px;
  }

  .page-body {
    height: calc(100% - 48px);
    overflow-y: auto;
    display: flex;
    gap: 8px;

    .company-profile-wrapper {
      display: flex;
      flex-direction: column;
      width: 550px;
      flex-shrink: 0;
      height: fit-content;

      .company-profile {
        margin-bottom: 8px;
        border-radius: 10px;
        background: white;


        .profile-header {
          border-radius: 10px;
          padding: 15px;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;

          .logo-section {
            display: flex;
            gap: 16px;

            .company-logo {
              width: 30px;
              height: 30px;
              border-radius: 50%;
              background: #FFD700;
              padding: 16px;
            }

            .company-info {
              .company-name {
                display: flex;
                align-items: center;
                gap: 12px;
                margin-bottom: 2px;

                h2 {
                  margin: 0;
                  font-size: 16px;
                  color: #333;
                  margin-bottom: 5px;
                }

                .status-badge {
                  background: #E6F7F7;
                  color: #06A1A1;
                  padding: 4px 12px;
                  border-radius: 16px;
                  font-size: 11px;
                }
              }

              .location {
                color: #666;
                font-size: 14px;
                display: flex;
                align-items: center;
                font-size: 10px;


                .location-icon {
                  width: 16px;
                  height: 16px;
                  margin-right: 4px;
                }
              }
            }
          }

          .account-opttions {
            display: flex;
            align-items: center;
            gap: 10px;

            .action-btn {
              .more {
                padding: 0;
                width: 30px;
                height: 30px;
              }
            }
          }
        }

        .company-details {
          padding-left: 23px;

          .detail-item {
            display: flex;
            align-items: center;
            gap: 12px;
            margin-bottom: 12px;
            color: #666;
            font-size: 14px;

            img {
              width: 16px;
              height: 16px;
            }

            &:last-child {
              margin-bottom: 0;
            }
          }
        }

        .description-section {
          padding: 24px;

          h3 {
            color: rgba(142, 142, 142, 1);
            font-size: 14px;
            margin: 0 0 5px 0;
            font-weight: 500;
            display: flex;
            align-items: center;
            gap: 10px;
          }

          p {
            color: #666;
            line-height: 1.6;
            margin: 0;
          }
        }
      }

      .row-widget {
        display: flex;
        gap: 8px;
      }

      .widget-container {
        background: white;
        border-radius: 10px;
        padding: 15px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        flex-grow: 1;
        margin-bottom: 8px;

        .widget-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;

          h3 {
            margin: 0;
            font-size: 15px;
            color: #333;
            font-weight: 600;
          }

          .view-more {
            color: rgba(8, 132, 175, 1);
            cursor: pointer;
            font-size: 12px;
            display: flex;
            align-items: center;
            gap: 4px;
            text-decoration: none;
            padding: 0px 16px;

          }

        }


        // Contacts Section
        .contacts-list {}

        .stats-section {
          display: flex;
          justify-content: center;
          gap: 24px;

          .total-stats {
            width: 120px;
            margin-bottom: 24px;
            padding-top: 2px;

            .stat-label {
              color: rgba(175, 175, 175, 1);
              font-size: 14px;
            }

            .stat-number {
              font-size: 40px;
              color: #1BA5A4;
              font-weight: 600;
              line-height: 1.2;
            }
          }

          .stat-bars {
            width: calc(100% - 144px);
            padding-right: 10px;

            .stat-item {
              margin-bottom: 8px;

              .percentage {
                color: #06a1a1;
                font-size: 12px;
                margin-bottom: 2px;

                &.p-secondary {
                  color: rgba(8, 132, 175, 1);
                }
              }

              .progress-bar {
                height: 8px;
                background: #fff;
                border-radius: 4px;
                margin: 2px 0;
                padding-right: 62px;

                .progress {
                  height: 100%;
                  background: #06a1a1;
                  border-radius: 4px;
                  transition: width 0.3s ease;
                  position: relative;

                  &.p-secondary {
                    background: rgba(8, 132, 175, 1);
                  }

                  .stat-label {
                    color: #666;
                    position: absolute;
                    right: -92px;
                    top: -4px;
                    font-size: 11px;
                    width: 90px;
                  }

                }


              }
            }
          }
        }


        .attachments-section {
          margin-bottom: 30px;

          h3 {
            color: rgba(142, 142, 142, 1);
            font-size: 12px;
            margin: 0 0 16px 0;
            font-weight: 500;
            display: flex;
            align-items: center;
            gap: 10px;
          }

          .attachment-files {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;

            .file-item {
              display: flex;
              align-items: center;
              gap: 16px;
              padding: 12px;
              border-radius: 8px;
              background: #F8F9FA;

              .file-icon {
                background: #FF6B6B;
                color: white;
                padding: 8px 12px;
                border-radius: 4px;
                font-size: 12px;
                font-weight: 500;
              }

              .file-info {
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                gap: 4px;

                .file-name {
                  color: #333;
                  font-size: 14px;
                }

                .file-details {
                  color: #666;
                  font-size: 12px;
                }
              }

              .file-actions {
                display: flex;
                gap: 8px;

                .action-btn {
                  background: none;
                  border: none;
                  padding: 8px;
                  cursor: pointer;
                  color: #666;
                  border-radius: 4px;
                  transition: all 0.2s;

                  &:hover {
                    background: #f0f0f0;
                  }

                  &.delete:hover {
                    color: #FF6B6B;
                  }
                }
              }
            }
          }
        }

        .contracts-section {
          h3 {
            color: rgba(142, 142, 142, 1);
            font-size: 14px;
            margin: 0 0 8px 0;
            font-weight: 500;
          }

          .contracts-signed {
            display: flex;
            align-items: center;
            gap: 10px;

            span {
              font-size: 40px;
              color: #1BA5A4;
              font-weight: 600;
              line-height: 1.2;
            }

          }
        }

      }
    }

    .overview-grid {
      display: flex;
      flex-direction: column;
      gap: 8px;
      flex-grow: 1;
      height: fit-content;

      .row-widget {
        display: flex;
        gap: 8px;
      }

      .widget-container {
        background: white;
        border-radius: 10px;
        padding: 15px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        flex-grow: 1;

        .widget-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;

          h3 {
            margin: 0;
            font-size: 15px;
            color: #333;
            font-weight: 600;
          }

          .view-more {
            color: rgba(8, 132, 175, 1);
            cursor: pointer;
            font-size: 12px;
            display: flex;
            align-items: center;
            gap: 4px;
            text-decoration: none;
            padding: 0px 16px;
          }

        }

        // Task Planner & Leads Section


        .task-stats,
        .leads-stats {
          display: flex;
          gap: 32px;
          justify-content: center;

          .total-tasks,
          .total-leads {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            margin-bottom: -9px;

            .stat-number {
              font-size: 40px;
              font-weight: 600;
              color: #06a1a1;
              line-height: 1.2;
            }

            .stat-label {
              color: rgba(175, 175, 175, 1);
              font-size: 14px;
            }
          }

          .task-bars,
          .lead-bars {
            display: flex;
            gap: 1px;
            align-items: flex-end;
            flex-grow: 1;
            padding-top: 0px;

            .task-bar,
            .lead-bar {
              flex: 1;
              display: flex;
              flex-direction: column;
              align-items: center;

              .progress-wrapper {
                height: 100px;
                width: 6px;
                background: #fff;
                border-radius: 4px;
                margin-bottom: 8px;
                display: flex;
                align-items: flex-end;
                position: relative;

                .progress {
                  width: 100%;
                  background: #06a1a1;
                  position: absolute;
                  bottom: 0;
                  border-radius: 4px 4px 0 0;
                  transition: height 0.3s ease;
                  position: relative;

                  .percentage {
                    font-size: 10px;
                    color: #666;
                    position: absolute;
                    right: -6px;
                    top: -14px;
                  }

                }
              }


              label {
                font-size: 11px;
                color: #999;
              }
            }
          }
        }

        // Activity Section
        .activity-stats {

          .activity-panels {
            display: flex;
            gap: 24px;

            .recent-activity {
              width: 100%;

              .activity-item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 8px 12px;
                border: 1px solid rgba(91, 91, 91, 0.05);
                border-radius: 7px;
                margin-bottom: 12px;

                .activity-text {
                  flex-grow: 1;
                  color: #333;
                }

                .activity-time {
                  font-size: 12px;
                  color: #666;
                  margin: 0 16px;
                }

                .activity-type {
                  font-size: 12px;
                  padding: 4px 12px;
                  border-radius: 16px;
                  font-weight: 500;

                  &.call {
                    background: #fff8e5;
                    color: #ffd700;
                  }

                  &.reminder {
                    background: #ffe5f2;
                    color: #ff69b4;
                  }
                }
              }
            }

          }


        }

        .lia-stats {

          .lia-panels {
            display: flex;
            gap: 24px;

            .recent-lia {
              width: 100%;

              .lia-item {
                display: grid;
                grid-template-columns: 1fr 2fr 1fr;
                align-items: center;
                padding: 12px 0;
                border: 1px solid rgba(91, 91, 91, 0.05);
                border-radius: 10px;
                margin-bottom: 12px;
                padding: 12px;

                .lia-title {
                  font-size: 12px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }

                .lia-time {
                  color: #666;
                  margin: 0 16px;
                  display: flex;
                  justify-content: flex-end;
                }

              }
            }

          }


        }

        .lia-genelated-section {
          h3 {
            color: rgba(142, 142, 142, 1);
            font-size: 14px;
            margin: 0 0 8px 0;
            font-weight: 500;
          }

          .lia-generated {
            display: flex;
            align-items: center;
            gap: 10px;

            span {
              font-size: 40px;
              color: #1BA5A4;
              font-weight: 600;
              line-height: 1.2;
            }
          }
        }


      }
    }
  }
}

.input-flex {
  display: flex;
}
</style>